const logo = {
  RSS_COLORED: 'rssColored',
  RSS_WHITE: 'rssWhite',
};

export default logo;
